'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagKeAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 4.17233e-06C9.33334 4.17233e-06 18.6667 4.34893e-05 28 0V20C18.6667 20 9.33334 20 1.0252e-05 20C1.0252e-05 13.3333 7.63282e-05 6.66667 0 4.17233e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.0252e-05 5.33334H28V0L0 4.17233e-06L1.0252e-05 5.33334Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.0252e-05 20H28V14.6667H1.0252e-05V20Z",
          fill: "#018301"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.0252e-05 14.6667H28V5.33334H1.0252e-05V14.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.0252e-05 13.3333H28V6.66667H1.0252e-05V13.3333Z",
          fill: "#DC0808"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 16.6667C15.3333 16.6667 17.3333 14.0501 17.3333 10C17.3333 5.94991 15.3333 3.33334 14 3.33334C12.6667 3.33334 10.6667 5.94991 10.6667 10C10.6667 14.0501 12.6667 16.6667 14 16.6667Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.6866 16.4671C15.3412 16.1069 16.0422 15.2715 16.5581 14.0635C16.2055 12.9003 16 11.503 16 10C16 8.49705 16.2055 7.09969 16.5581 5.93653C15.854 4.28798 14.8054 3.33335 14 3.33334C13.1946 3.33334 12.1461 4.28797 11.4419 5.93653C11.7945 7.09969 12 8.49705 12 10C12 11.503 11.7945 12.9003 11.4419 14.0635C12.0004 15.3709 12.7754 16.2418 13.474 16.5463C13.6563 16.6258 13.8333 16.6667 14 16.6667C14.1007 16.6667 14.2052 16.6518 14.3123 16.6224C14.4342 16.5891 14.5595 16.537 14.6866 16.4671Z",
          fill: "#BC0000"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.6667 5.33331C14.6667 6.80607 14.3682 7.99998 14 7.99998C13.6319 7.99998 13.3334 6.80607 13.3334 5.33331C13.3334 4.58741 13.4099 3.91303 13.5333 3.42906C13.6947 3.36577 13.8515 3.33334 14 3.33334C14.1485 3.33334 14.3054 3.36577 14.4667 3.42908C14.5901 3.91305 14.6667 4.58742 14.6667 5.33331Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.4668 16.5709C14.5902 16.0869 14.6667 15.4125 14.6667 14.6666C14.6667 13.1939 14.3682 12 14 12C14.3682 12 14.6667 11.1045 14.6667 9.99998C14.6667 8.89541 14.3682 7.99998 14 7.99998C13.6319 7.99998 13.3334 8.89541 13.3334 9.99998C13.3334 11.1045 13.6319 12 14 12C13.6319 12 13.3334 13.1939 13.3334 14.6666C13.3334 15.4125 13.4099 16.0869 13.5333 16.5709C13.6947 16.6342 13.8515 16.6667 14 16.6667C14.1485 16.6667 14.3054 16.6342 14.4668 16.5709Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagKeAsset = forwardRef(FlagKeAsset);

export { VpFlagKeAsset as default };
